/**
 * @generated SignedSource<<24c69d10a0df7de373faaadd49b6096e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandLoginCallbackInput = {
  clientMutationId?: string | null | undefined;
  code: string;
  userId: string;
};
export type LoginCallbackMutation$variables = {
  input: BrandLoginCallbackInput;
};
export type LoginCallbackMutation$data = {
  readonly brandLoginCallback: {
    readonly ok: boolean;
  } | null | undefined;
};
export type LoginCallbackMutation = {
  response: LoginCallbackMutation$data;
  variables: LoginCallbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandLoginCallbackPayload",
    "kind": "LinkedField",
    "name": "brandLoginCallback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginCallbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginCallbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4dd5e6828c9fbb5f7e8b827a8da992b",
    "id": null,
    "metadata": {},
    "name": "LoginCallbackMutation",
    "operationKind": "mutation",
    "text": "mutation LoginCallbackMutation(\n  $input: BrandLoginCallbackInput!\n) {\n  brandLoginCallback(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c3ce1512e3b2d5350ac58e44908dae8";

export default node;
